import React from 'react';

/** PDF illustration — 3 fanned pages, center upright, flanks rotated. */
const FannedPages = () => (
  <div className="ill-pages" aria-hidden="true">
    <div className="ill-page ill-page-l">
      <span className="ill-bar ill-bar-accent"></span>
      <span className="ill-bar"></span>
      <span className="ill-bar ill-bar-short"></span>
      <span className="ill-bar"></span>
    </div>
    <div className="ill-page ill-page-c">
      <span className="ill-bar ill-bar-accent"></span>
      <span className="ill-bar"></span>
      <span className="ill-bar"></span>
      <span className="ill-bar ill-bar-short"></span>
      <span className="ill-bar"></span>
    </div>
    <div className="ill-page ill-page-r">
      <span className="ill-bar ill-bar-accent"></span>
      <span className="ill-bar ill-bar-short"></span>
      <span className="ill-bar"></span>
      <span className="ill-bar"></span>
    </div>
  </div>
);

export default FannedPages;
